module.exports = __webpack_public_path__ + "static/img/hotwind1.7cc04c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotwind1.png
// module id = O7gG
// module chunks = 2